import React from 'react';
import { TinaMarkdown, TinaMarkdownContent } from 'tinacms/dist/rich-text';
import styled from 'styled-components';

const Container = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  li {
    color: ${({ theme }) => theme.themeColors.fg};
  }
`;

interface TinaRichText {
  components?: object;
  content?: TinaMarkdownContent | null;
}

const TinaRichText: React.FC<TinaRichText> = ({ components, content }) => {
  if (!content) {
    return null;
  }
  return (
    <Container className="rich-text">
      <TinaMarkdown content={content} components={components} />
    </Container>
  );
};

export default TinaRichText;
